ACC.silentorderpost = {

    _autoload: [
        'bindUseDeliveryAddress',
        'bindSubmitSilentOrderPostForm',
        'bindCreditCardAddressForm',
        ['bindSavedCards', $('.savedCardRadioBtn').length !== 0],
        'bindSavedCardAddYourCardAgain',
        'selectErrorCard',
        'selectedCard',
        'preselectCard',
        ['updateBillingAddressForm', $('#billingCountrySelector').length && !$('#useDeliveryAddress').length]],

    spinner: $(`<img src='${ACC.config.commonResourcePath}/images/spinner.gif' />`),

    selectErrorCard() {
        const selectedCardId = $('#selectedCardId').val();
        if (typeof selectedCardId === 'undefined' || selectedCardId === '') return;

        const card = $(`#savedCard-${selectedCardId}`);
        ACC.silentorderpost.checkRadioBlock(card);
    },

    selectedCard() {
        const radioBtn = $('.savedCardRadioBtn');
        if (radioBtn.is(':checked')) {
            const checkedRadio = $('.creditCardDetails').find('input:checked');
            ACC.silentorderpost.checkRadioBlock(checkedRadio);
        }
    },

    checkRadioBlock(checkedRadio) {
        if (checkedRadio.attr('id') === 'savedCard-newCard') {
            ACC.silentorderpost.showPaymentForm();
            // check if shipping address is present
            if ($('.checkout-order-summary-list-heading').length) {
                const useDeliveryAddress = $('#useDeliveryAddress');
                ACC.silentorderpost.toggleBillingAddressForm(useDeliveryAddress);
            }
        } else {
            const savedCardId = checkedRadio.data('savedcardid');
            const card = $(`#savedCard-${savedCardId}`);

            $(`#cardCvv-${savedCardId}`).css('display', 'flex');
            $(`#removeEntry_${savedCardId}`).show();
            $('#savedCardBillingAddressData').html(card.data('cardbillingaddress'));

            ACC.silentorderpost.showSavedCardBillingAddress();
            ACC.silentorderpost.addEventToRemoveCard(savedCardId);
        }

        checkedRadio
            .prop('checked', true)
            .closest('.c-radiobtn')
            .addClass('selected');
        ACC.silentorderpost.showPlaceOrderBtn();
    },

    bindUseDeliveryAddress() {
        const component = $('#useDeliveryAddress');
        if (!component.length) return;
        component.on('change', () => {
            ACC.silentorderpost.enableSaveCardCheckBox();
            if (component.is(':checked')) {
                ACC.silentorderpost.hideBillingAddressForm();
                ACC.silentorderpost.preFillBillingForm();
            } else {
                ACC.silentorderpost.showBillingAddressForm();
                ACC.silentorderpost.clearAddressForm();
                ACC.silentorderpost.enableAddressForm();
            }
        });
        ACC.silentorderpost.toggleBillingAddressForm(component);
    },

    bindSavedCards() {
        const component = $('.savedCardRadioBtn');
        component.on('change', function () {
            if (component.is(':checked')) {
                const selectedComponent = $(this);
                ACC.silentorderpost.removeCardMessageValidation();
                $('.selected').removeClass('selected');
                selectedComponent.parent().toggleClass('selected');
                selectedComponent.closest('.c-boxed').toggleClass('selected');

                if (selectedComponent.attr('id') === 'savedCard-newCard') {
                    const useDeliveryAddress = $('#useDeliveryAddress');

                    ACC.silentorderpost.hideSavedCardBillingAddress();
                    ACC.silentorderpost.hideSavedCardCvvInput();
                    ACC.silentorderpost.hideRemoveCardButton();
                    ACC.silentorderpost.showPaymentForm();
                    ACC.silentorderpost.toggleBillingAddressForm(useDeliveryAddress);
                } else {
                    const savedCardId = selectedComponent.data('savedcardid');
                    $('#savedCardBillingAddressData').html(selectedComponent.data('cardbillingaddress'));
                    ACC.silentorderpost.showSavedCardBillingAddress();
                    ACC.silentorderpost.hideSavedCardCvvInput();
                    ACC.silentorderpost.hideRemoveCardButton();
                    $(`#cardCvv-${savedCardId}`).css('display', 'flex');
                    $(`#removeEntry_${savedCardId}`).show();
                    ACC.silentorderpost.addEventToRemoveCard(savedCardId);
                    ACC.silentorderpost.hidePaymentForm();
                    // eslint-disable-next-line max-len
                    ACC.silentorderpost.updateBillingAddressFromSavedCard(savedCardId, selectedComponent.data('countryisocode'));
                    if (ACC.config.isHedThemeEnabled && ACC.addressDoctorHED.isInlineAddressDoctorEnabled()) {
                        ACC.addressDoctorHED.editedRecommendedAddress = true;
                        ACC.addressDoctorCheckout.isSavedFlow = false;
                    }
                }

                $("[data-radio-child-group='verificationType']").hide();
                $('#payPalType').prop('checked', false);
                if ($('.applePayMethod').length !== 0) {
                    $('#applePayRadioBtn').prop('checked', false);
                    ACC.applePayHelpers.hideApplePayBlock();
                }

                $('#payinternType').prop('checked', false);
                $('#zipPayType').prop('checked', false);
                ACC.silentorderpost.showPlaceOrderBtn();
            }
        });
    },

    updateBillingAddressFromSavedCard(savedCardId, countryIsoCode) {
        ACC.secureacceptance.wrapWithOneByOneExecutionHandling((deferred) => {
            const options = {
                countryIsoCode,
                useDeliveryAddress: false,
                savedCardId,
            };

            ACC.silentorderpost.displayCreditCardAddressForm(options, () => {
                ACC.silentorderpost.fillCountrySelectBox(options.countryIsoCode);
                ACC.silentorderpost.updateBillingAddressForSavedCardAndRecalculateOrder(deferred, savedCardId);
            });
        })();
    },

    updateBillingAddressForSavedCardAndRecalculateOrder(recalculateOrderDeferred, savedCardId) {
        // eslint-disable-next-line max-len
        const form = ACC.config.isUnifiedWalletEnabled ? ACC.unifiedWallet.setBillingAddressForSavedCard(GLOBAL_PAYMENT_DATA, savedCardId) : ACC.secureacceptance.collectBillingAddressForm();
        $.ajax({
            type: 'POST',
            url: `${ACC.config.encodedContextPath}/checkout/multi/validate/updateBillingAddressForSavedCard`,
            data: form,
            dataType: 'html',
            async: true,
            success(data) {
                // update order totals displayed to the customer
                // eslint-disable-next-line no-undef
                $('.orderTotals').html(DOMPurify.sanitize(data));
                ACC.secureacceptance.reloadSopForm();
                recalculateOrderDeferred.resolve();
            },
            error(xhr, status, error) {
                console.error(error.message);
                window.location.reload();
            },
        });
    },

    bindSavedCardAddYourCardAgain() {
        $('.savedCardAddYourCardAgain').on('click', (e) => {
            e.preventDefault();
            $('.savedCardRadioBtn').prop('checked', false);
            $('#savedCard-newCard').prop('checked', true);
            $('.selected').removeClass('selected');
            $('#savedCard-newCard').parent().toggleClass('selected');
            ACC.silentorderpost.hideSavedCardBillingAddress();
            ACC.silentorderpost.hideSavedCardCvvInput();
            ACC.silentorderpost.hideRemoveCardButton();
            ACC.silentorderpost.showPaymentForm();
            const useDeliveryAddress = $('#useDeliveryAddress');
            ACC.silentorderpost.toggleBillingAddressForm(useDeliveryAddress);
            ACC.checkoutPreValid.init();
        });
    },

    addEventToRemoveCard(savedCardId) {
        const component = $(`#removeCardButton_${savedCardId}`);
        if (!component.length) return;
        component.on('click', (e) => {
            e.preventDefault();

            // Ajax call to remove the card
            $.ajax({
                type: 'POST',
                url: `${ACC.config.encodedContextPath}/checkout/multi/summary/${savedCardId}/removeCard`,
                async: false,
                error() {
                    const messageKey = 'checkout.multi.summary.card.remove.error';
                    const globalMessageRequest = {
                        globalMessages: [{
                            messageHolder: 'accErrorMsgs',
                            messages: [messageKey],
                        }],
                    };
                    ACC.globalmessages.createGlobalMessage(globalMessageRequest);
                },
                success() {
                    // used window replace in order not to allow the user to go back
                    window.location.replace(`${ACC.config.encodedContextPath}/checkout/multi/summary/enter`);
                },
                timeout: 3000, // sets request timeout to 3 seconds
            });
        });
    },

    preFillBillingForm() {
        const options = {
            countryIsoCode: $('#useDeliveryAddressData').data('countryisocode'),
            useDeliveryAddress: true,
        };
        ACC.silentorderpost.enableAddressForm();
        ACC.silentorderpost.displayCreditCardAddressForm(options, ACC.silentorderpost.useDeliveryAddressSelected);
        ACC.silentorderpost.disableAddressForm();
    },

    preFillBillingFormForQuoteCheckout() {
        const options = {
            countryIsoCode: $('#useDeliveryAddressData').data('countryisocode'),
            useDeliveryAddress: false,
        };
        ACC.silentorderpost.enableAddressForm();
        ACC.silentorderpost.displayCreditCardAddressForm(options, ACC.silentorderpost.fillCountrySelectBox);
    },
    preFillBillingFormWhenPaymentError() {
        const options = {
            countryIsoCode: $('#useBillingAddressData').data('countryisocode'),
            useDeliveryAddress: false,
            hasPaymentErrors: true,
        };
        ACC.silentorderpost.enableAddressForm();
        ACC.silentorderpost.displayCreditCardAddressForm(options, ACC.silentorderpost.fillCountrySelectBox);
    },

    bindSubmitSilentOrderPostForm() {
        $('.submit_silentOrderPostForm').click(function () {
            ACC.common.blockFormAndShowProcessingMessage($(this));
            $('.billingAddressForm').filter(':hidden').remove();
            ACC.silentorderpost.enableAddressForm();
            $('#silentOrderPostForm').submit();
        });
    },

    bindCycleFocusEvent() {
        $('#lastInTheForm').blur(() => {
            $('#silentOrderPostForm [tabindex$="10"]').focus();
        });
    },

    isEmpty(obj) {
        if (typeof obj === 'undefined' || obj === null || obj === '') return true;
        return false;
    },

    disableAddressForm() {
        $('input[id^="address\\."]').prop('disabled', true);
        $('select[id^="address\\."]').prop('disabled', true);
        $('select.form-control').prev().addClass('disabled');
    },

    enableAddressForm() {
        $('input[id^="address\\."]').prop('disabled', false);
        $('select[id^="address\\."]').prop('disabled', false);
        $('select.form-control').prev().removeClass('disabled');
    },

    clearAddressForm() {
        $('input[id^="address\\."]').val('');
        $('select[id^="address\\."]').filter(function () {
            return !this.id.match(/country/);
        }).val('');
    },

    fillCountrySelectBox(countryIsoCode) {
        const country = $('#address\\.country');

        if (ACC.global.isUndefinedOrNull(countryIsoCode)) {
            country.val($('#useDeliveryAddressData').data('countryisocode'));
        } else {
            country.val(countryIsoCode);
        }
    },

    useDeliveryAddressSelected() {
        if ($('#useDeliveryAddress').is(':checked')) {
            ACC.silentorderpost.fillCountrySelectBox();
            ACC.silentorderpost.disableAddressForm();
        } else {
            ACC.silentorderpost.clearAddressForm();
            ACC.silentorderpost.enableAddressForm();
        }
    },

    enableSaveCardCheckBox() {
        const isWorldwideCountrySelected = $('#worldwideCountrySelected').data('worldwide-country-selected');
        const cardSaveCheckBox = $('#card_save_payment_info');
        if (isWorldwideCountrySelected === true) {
            cardSaveCheckBox.prop('checked', false);
            cardSaveCheckBox.attr('disabled', 'disabled');
            $('.js-card-save-payment-info-alert').show();
        } else {
            cardSaveCheckBox.removeAttr('disabled');
            $('.js-card-save-payment-info-alert').hide();
        }
    },

    bindCreditCardAddressForm() {
        $('#billingCountrySelector :input').on('change', ACC.silentorderpost.updateBillingAddressForm);
    },

    updateBillingAddressForm() {
        const countrySelection = $('#address\\.country option:selected').val();
        const options = {
            countryIsoCode: countrySelection,
            useDeliveryAddress: false,
        };
        ACC.silentorderpost.displayCreditCardAddressForm(options);
    },

    displayCreditCardAddressForm(options, callback) {
        $.ajax({
            url: `${ACC.config.encodedContextPath}/checkout/multi/sop/billingaddressform`,
            async: true,
            data: options,
            dataType: 'html',
            beforeSend() {
                $('#billingAddressForm').html(ACC.silentorderpost.spinner);
            },
        }).done((data) => {
            $('#billingAddressForm').html(data);
            if (typeof callback === 'function') {
                callback.call();
            }
            ACC.silentorderpost.enableSaveCardCheckBox();
            ACC.secureacceptance.bindBillingAddressListeners();
            ACC.phonemasking.bind($('#address\\.phone'), options.countryIsoCode);
        });
    },

    toggleBillingAddressForm(component) {
        const hasPaymentErrors = $('#useBillingAddressData').data('haspaymenterrors');
        const deliveryAddressId = $('#useDeliveryAddressData').data('address-id');
        const billingAddressId = $('#useBillingAddressData').data('address-id');
        if (component.data('is-quote-checkout') || hasPaymentErrors) {
            component.prop('checked', false);
            ACC.silentorderpost.showBillingAddressForm();
            if (hasPaymentErrors && (deliveryAddressId !== billingAddressId)) {
                ACC.silentorderpost.preFillBillingFormWhenPaymentError();
            } else if (hasPaymentErrors && (deliveryAddressId === billingAddressId)) {
                component.prop('checked', true);
                ACC.silentorderpost.hideBillingAddressForm();
                ACC.silentorderpost.preFillBillingForm();
            } else {
                ACC.silentorderpost.preFillBillingFormForQuoteCheckout();
            }
        } else if ($('.floated-sidebar').length !== 0) {
            component.prop('checked', true);
            ACC.silentorderpost.showBillingAddressForm();
        } else {
            if (ACC.config.isHedThemeEnabled && ACC.addressDoctorHED.isInlineAddressDoctorEnabled()
                && ACC.addressDoctorCheckout.isSavedFlow) {
                component.prop('checked', false);
                ACC.silentorderpost.showBillingAddressForm();
                return;
            }
            component.prop('checked', true);
            ACC.silentorderpost.hideBillingAddressForm();
            ACC.silentorderpost.preFillBillingForm();
        }
    },

    showBillingAddressForm() {
        $('#ccBillingAddressForm').fadeIn();
        $('#ccDeliveryAddress').hide();
    },

    hideBillingAddressForm() {
        $('#ccBillingAddressForm').hide();
        $('#ccDeliveryAddress').fadeIn();
    },

    showPaymentForm() {
        $('.checkout-paymentmethod').fadeIn();
    },

    hidePaymentForm() {
        $('.checkout-paymentmethod').hide();
    },

    showPlaceOrderBtn() {
        $('.place-order-form').fadeIn();
    },

    showSavedCardBillingAddress() {
        $('#savedCardBillingAddress').fadeIn();
    },

    hideSavedCardBillingAddress() {
        $('#savedCardBillingAddress').hide();
    },

    hideSavedCardCvvInput() {
        $('#savedPaymentCards .c-saved-card .saved-card-cvv').removeClass('show-cvv-error-spacing');
        $('.saved-card-cvv').hide();
    },

    removeCardMessageValidation() {
        $('.saved-card-cvv').removeClass('has-error');
        $('.saved-card-cvv .help-block').remove();
        $('.form-group').removeClass('has-error');
        $('.checkout-paymentmethod .help-block').remove();
    },
    hideRemoveCardButton() {
        $('.js-cartItemDetailBtn').hide();
    },

    preselectCard() {
        const reorderType = 'REORDER';
        if ($('#checkoutType').val() === reorderType) {
            const previouslySelectedCard = $('.savedCardRadioBtn[data-checked="true"]');

            if (previouslySelectedCard.length) {
                previouslySelectedCard.click();
            } else {
                $('.payment-info').html('');
            }
        }
    },
};
